var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85355 8.14645C8.65829 7.95118 8.34171 7.95118 8.14645 8.14645C7.95118 8.34171 7.95118 8.65829 8.14645 8.85355L11.2932 12.0003L8.14669 15.1468C7.95142 15.342 7.95142 15.6586 8.14669 15.8539C8.34195 16.0491 8.65853 16.0491 8.85379 15.8539L12.0003 12.7074L15.1465 15.8536C15.3418 16.0489 15.6584 16.0489 15.8536 15.8536C16.0489 15.6584 16.0489 15.3418 15.8536 15.1465L12.7074 12.0003L15.8539 8.85379C16.0491 8.65853 16.0491 8.34195 15.8539 8.14668C15.6586 7.95142 15.342 7.95142 15.1468 8.14668L12.0003 11.2932L8.85355 8.14645Z",
    fill: "#CE0505"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#CE0505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveOrange);
export default __webpack_public_path__ + "static/media/RemoveOrange.7d553ebc0a860ed03aa382da66ada1a9.svg";
export { ForwardRef as ReactComponent };